import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-logo">SYGMATEC</h3>
            <p className="footer-tagline">
              Empowering the Future with Smart Solutions
            </p>
            <div className="footer-contact-item">
              <Mail size={18} />
              <div className="footer-contact-emails">
                <span>Info@hs-sygmatec.com</span>
                <span>Info@sygmatec.in</span>
              </div>
            </div>
            <div className="footer-contact-item">
              <Phone size={18} />
              <span>+91 407069565</span>
            </div>
            <div className="footer-contact-item">
              <MapPin size={18} />
              <span>21-111, 7th Cross Road, Uttamnagar, Safilguda, Hyderabad - 500047</span>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><a href="/#solutions">Solutions</a></li>
              <li><a href="/#themes">Themes</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Solutions</h4>
            <ul className="footer-links">
              <li><a href="#solutions">ICCC</a></li>
              <li><a href="#solutions">Video Analytics</a></li>
              <li><a href="#solutions">Smart Lighting</a></li>
              <li><a href="#solutions">IoT Solutions</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Themes</h4>
            <ul className="footer-links">
              <li><a href="#themes">Smart Temples</a></li>
              <li><a href="#themes">Smart Buildings</a></li>
              <li><a href="#themes">Smart Energy</a></li>
              <li><a href="#themes">Smart Stadiums</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright">
            © {currentYear} Sygmatec Smart Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
